import { useRouter } from 'next/router'
export const useIsEmbed = () => {
  const router = useRouter()
  return Boolean(router.pathname.match(/\/embed/))
}
